import type { Theme, ThemeOptions } from '@mui/material/styles';

export function chipThemeComponents(theme: Theme): ThemeOptions['components'] {
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          '&.SmChip-root': {
            fontWeight: 400,
            paddingInline: 6,
            boxSizing: 'border-box',

            '&.SmChip-deletable': {
              justifyContent: 'flex-start',
              '& .MuiChip-label': {
                textAlign: 'right',
                paddingRight: 10,
                paddingLeft: 0
              }
            },

            '& .MuiChip-label': {
              paddingLeft: 10,
              paddingRight: 10
            },

            '& .SmChip-icon': {
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: 6,
              marginRight: -4,

              '& .MuiSvgIcon-root, & > svg': {
                fontSize: 13
              }
            },

            '& .MuiChip-deleteIcon': {
              order: -1,
              marginRight: 10,
              marginLeft: 2,
              color: theme.palette.common.white,

              fontSize: 13,
              backgroundColor: '#a0acc0',
              borderRadius: 6,
              padding: 2,
              boxSizing: 'border-box',
              '&.MuiSvgIcon-root': {
                fontSize: 13,
                backgroundColor: '#a0acc0',
                borderRadius: 6,
                padding: 2,
                color: theme.palette.common.white
              },
              '& .MuiSvgIcon-root, & > svg': { fontSize: 13, color: theme.palette.common.white }
            },

            '&.MuiChip-sizeSmall': {
              height: 26,
              fontSize: 13
            },

            '&.MuiChip-sizeMedium': {
              height: 30,
              fontSize: 13
            },

            '&.SmChip-style-filled': {
              border: '1px solid transparent'
            },

            '&.SmChip-style-outlined': {
              backgroundColor: 'transparent',
              border: `1px solid ${theme.palette.divider}`
            },

            '&.SmChip-variant-primary': {
              backgroundColor: '#F2F4F9',
              color: '#1E2A3A'
            }
          }
        }
      }
    }
  };
}
